import { api } from "../../lib/api";
import { getGoogleMapsApiKey } from "../../lib/getEnvVariables";
export const getProjectListData = async (queryParams) => {
    const { data } = await api.post(`/projects/search${queryParams && "?" + queryParams}`);
    return data; // return the data if the API call succeeds
};
export const getProjectAssetsData = async (id, queryParams) => {
    const { data } = await api.post(`/projects/${id}/assets/search${queryParams && "?" + queryParams}`);
    return data;
};
export const getUsageHistoryDetailsData = async (id, startDate, aggregation, assetSourceType, assetId) => {
    const config = { params: { aggregation, assetSourceType, startDate, ...(assetId && { assetId }) } };
    const { data } = await api.get(`/projects/${id}/energy/histogram`, config);
    return data;
};
export const getProjectEnergyMetricsData = async (id, startDate) => {
    const config = { params: { startDate } };
    const { data } = await api.get(`/projects/${id}/energy/metrics`, config);
    return data;
};
export const getProjectNetworkData = async (id) => {
    const { data } = await api.get(`/projects/${id}/network/connections`);
    return data;
};
export const getProjectEnergyActivitiesData = async (id, startDate) => {
    const config = { params: { startDate } };
    const { data } = await api.get(`/projects/${id}/energy/activities`, config);
    return data;
};
export const getProjectAssetChargeActivitiesData = async (id, startDate) => {
    const { data } = await api.post(`/projects/${id}/assets/events/search?startDate=${startDate}`);
    return data;
};
export const getProjectAssetChargeActivitiesDataWithAssetId = async (id, startDate, assetId) => {
    const requestParams = {
        filters: [
            {
                propertyName: "assetId",
                type: "stringEquals",
                values: [assetId]
            }
        ]
    };
    const { data } = await api.post(`/projects/${id}/assets/events/search?startDate=${startDate}`, requestParams);
    return data;
};
export const getMapDirectionData = async (routeSources) => {
    const config = {
        headers: {
            "X-Goog-Api-Key": getGoogleMapsApiKey(),
            "X-Goog-FieldMask": "routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline,routes.legs"
        }
    };
    const routes = await Promise.all(routeSources.map(async (routeSource) => {
        const requestBody = JSON.stringify({
            destination: routeSource.destination,
            origin: routeSource.origin,
            travelMode: "DRIVE"
        });
        const { data } = await api.post(`https://routes.googleapis.com/directions/v2:computeRoutes`, requestBody, config);
        return {
            destAssetName: routeSource.destAssetName,
            id: routeSource.id,
            routeData: data.routes[0],
            srcAssetName: routeSource.srcAssetName,
            srcAssetNameFull: routeSource.srcAssetNameFull,
            srcAssetNameToOthers: routeSource.srcAssetNameToOthers
        };
    }));
    return { routes };
};
export const getAssetSocChartDetailsData = async (assetId) => {
    const { data } = await api.post(`/assets/${assetId}/idle/burndown`);
    return data;
};
